// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__Wk+M6","list":"Footer_list__nYGCj"};